<section class="cst_body">
  <div class="container-fluid search_flt_box_main">
    <!-- need to write -->
    <!-- <div class="search_flt_box">
      <div class="row">
        <div class="col-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Search By</label>
            <select class="form-control col-form-label-sm">
              <option>mobile</option>
              <option>mrn</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Search By</label>
            <select class="form-control col-form-label-sm">
              <option>mobile</option>
              <option>mrn</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Enter Value</label>
            <input type="text" class="form-control col-form-label-sm" placeholder="Enter Value">
          </div>
        </div>
        <div class="col-2">
          <button type="submit" class="btn green_btn">Search</button>&nbsp;

        </div>

      </div>
    </div> -->
    <div class="search_flt_box">
      <div class="row">
        <div class="col-2">
          <div class="form-group">
            <label for="formGroupExampleInput">Client Name</label>
            <ng-select #tenantSelect  [items]="tenantsOrgList" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
              (clear)="resetTeantFilters();" bindLabel="organizationName" bindValue="tenantCode"
              placeholder="Select Client" (change)="onTenantOrgSearch($event)">
              <ng-options *ngFor="let item of tenantsOrgList " [Value]="item.tenantCode">{{item.organizationName}}
              </ng-options>
            </ng-select>
          </div>
          <!-- <div class="form-group">
            <label for="formGroupExampleInput">Client Name</label>
            <ng-select [items]="tenantsList" [multiple]="true" [closeOnSelect]="true" [clearable]="true"
              (clear)="resetTeantFilters();" bindLabel="tenantName" bindValue="tenantCode" placeholder="Select Client"
              (change)="onTenantSelect($event)">
              <ng-options *ngFor="let item of tenantsList " [Value]="item.tenantCode">{{item.tenantName}}
              </ng-options>
            </ng-select>

          </div> -->
        </div>
        <div class="col-2">
          <!-- <div class="form-group">
            <label for="formGroupExampleInput">Client Organization</label>
            <ng-select [items]="organizationsOfTenants" [multiple]="true" [closeOnSelect]="true" [clearable]="true"
              (clear)="resetTeantFilters();" bindLabel="organizationName" bindValue="organizationCode"
              placeholder="Select Client" (change)="onOrgSelect($event)">
              <ng-options *ngFor="let item of organizationsOfTenants  "
                [Value]="item.organizationCode">{{item.organizationName}}
              </ng-options>
            </ng-select>

          </div> -->
          <div class="form-group">
            <label for="formGroupExampleInput">Lead Status</label>
            <select class="form-control col-form-label-sm" [(ngModel)]="leadStaus">
              <option value="">ALL</option>
              <option value="NEW">NEW</option>
              <option value="INPROGRESS">INPROGRESS</option>
              <option value="COMPLETED">COMPLETED</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label>Select Daterange:</label>
            <div class="input-group">

              <input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker [bsValue]="bsRangeValue"
                (bsValueChange)="onValueChange($event)">
              <div class="input-group-append">
                <button class="btn btn-success" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen"
                  type="button"><i class="fa fa-calendar" aria-hidden="true"></i></button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1">
          <div class="form-group">
            <label for="formGroupExampleInput">Search By</label>
            <select class="form-control col-form-label-sm" [(ngModel)]="serchBy">
              <option value="mobile">mobile</option>
              <option value="mrn">mrn</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group" *ngIf="serchBy == 'mrn'">
            <label for="formGroupExampleInput">Enter Value</label>
            <input type="text" class="form-control col-form-label-sm" [(ngModel)]="mrnValue"  placeholder="Enter Value">
          </div>
          <div class="form-group" *ngIf="serchBy == 'mobile'">
            <label for="formGroupExampleInput">Enter Value</label>
            <input type="text" class="form-control col-form-label-sm" [(ngModel)]="mobileNOValue" minlength="10" maxlength="10" placeholder="Enter Value">
          </div>
        </div>
        <div class="col-3">
          <button type="submit" class="btn green_btn" (click)="getLeadsList()">Search</button>&nbsp;
          <button type="submit" class="btn green_btn" (click)="filterClear()">Clear</button>&nbsp;
          <button type="submit" class="btn green_btn" (click)="openLedsModal(addLeadsModal)">Add Leads</button>&nbsp;

        </div>

      </div>
    </div>
  </div>

  <div class="container-fluid" role="main">
    <div class="table_main tableShadow">
      <table class="table table-striped table-responsive">
        <thead>
          <tr class="tbl_name">
            <th>MRN</th>
            <th>Customer Name</th>
             <th>Mobile No</th> 
            <th>Customer Type</th>
            <!-- <th>Order DID</th> -->
            <!-- <th>Service Type</th> -->
            <th>Lead Created Date</th>
             <th>Plans</th> 
            <th >Status</th>
            <!-- <th>Vendor Name</th> -->
            <!-- <th class="ord_sts">Order Status</th> -->
            <!-- <th>Payment Status</th> -->
            <th>Actions &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
        </thead>
        <tbody *ngIf="leadsList.length > 0">
          <tr *ngFor="let data of leadsList;let i = index">
            <td>
              {{data.mrn}}
            </td>
            <td>
              {{data.customerName}}
            </td>
            <td>
              {{data.customerMobile}}
            </td>
            <td>
              <span *ngIf="data.isNewCustomer == 1">New</span>
              <span *ngIf="data.isNewCustomer == 0">Existing</span>
            </td>
            <td>
              {{data.createdTime | date:'dd/MM/yyyy hh:mm a'}}
            </td>
            <td>
                  <span *ngFor="let plan of data.plans">{{ plan.plan_name }}</span>
            </td>
            <td>
              <span *ngIf="!data?.orderPayStatus">{{data.leadStatus}}</span>
              <span *ngIf="data?.orderPayStatus">PAID</span>
            </td>
            <td>
              <img class="exitImg mx-1"  src="./assets/img/info.png" *ngIf="data.leadStatus == 'NEW'  && data.dischargeSummary !=='' && data.tenantCode =='1000267' " (click)="  openPlanAddModal(addPlansModal,data)" ngbTooltip="Add Plans">
              <img class="exitImg mx-1"  src="./assets/img/info.png" *ngIf="data.leadStatus == 'NEW' && data.tenantCode !='1000267' " (click)="  openPlanAddModal(addPlansModal,data)" ngbTooltip="Add Plans">
              <img class="exitImg mx-1" src="./assets/img/info.png" *ngIf="data.leadStatus == 'INPROGRESS'" (click)="  openledsToOrdersModal(ledsToOrdersModal,data)" ngbTooltip="Create Order">
              <!--<img class="exitImg" src="./assets/img/eye.png" *ngIf="data.leadStatus == 'COMPLETED'" (click)="  openShowLeadsHistoryModal(showLeadsHistoryModal,data)">-->
              
              <img class="exitImg mx-1" src="./assets/img/download.png" (click)="downloadReports(data.dischargeSummary)" *ngIf="data.dischargeSummary !=='' " ngbTooltip="Download Discharge Summary" >

              <img class="exitImg mx-1" *ngIf="data.dischargeSummary =='' && data.leadStatus == 'NEW'"  src="./assets/img/upload.png" width="25px" (click)="openUploadDischargeSummaryModal(uploadDischargeSummary,data)"  ngbTooltip="Upload Discharge Summary" >

              <img class="exitImg mx-1" *ngIf="  data.orderPayStatus " width="25px" src="./assets/img/send-email.png"  (click)="orderActivationEvent(data?.orderId)" ngbTooltip="Send Mail"  >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="leadsList.length == 0" class="noRecord"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="leadsList.length">
      <div class="totalRecords">
        Total Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="totalRecords" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)" >
      
    </ngb-pagination>
     </div> 
    </div>
  </div>
  <!-- <div *ngIf="!isOrderListDataExist">No Records Found</div> -->
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>
</section>

<ng-template #addLeadsModal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Lead Creation</p>

    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">
    <div class="row searchPanel">
      <div class="col-3">
        <div class="form-group">
          <label for="formGroupExampleInput">Client Name</label>
          <ng-select [items]="tenantsOrgList" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
            (clear)="resetTeantFilters();" bindLabel="organizationName" bindValue="tenantCode"
            placeholder="Select Client" (change)="onTenantOrgSelection($event)">
            <ng-options *ngFor="let item of tenantsOrgList " [Value]="item.tenantCode">{{item.organizationName}}
            </ng-options>
          </ng-select>
        </div>
      </div>
      <div col="col-2">
        <div class="form-group">
          <label for="formGroupExampleInput">Search By</label>
          <select class="form-control col-form-label-sm" [(ngModel)]="searchType">
            <option value="mobile">Mobile</option>
          </select>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <form [formGroup]="mobileNO_Form">
          <label for="formGroupExampleInput">Enter Value<span class="text-danger">*</span></label>
          <input type="text"  formControlName="mobile" minlength="10" maxlength="10" class="form-control col-form-label-sm"
            placeholder="Enter Value">
          </form>
        </div>
      </div>
      <div class="col-1" style="margin-top:30px ;">
        <div class="form-group">
          <button type="submit" class="btn green_btn" [disabled]="mobileNO_Form.invalid || selectedOrgCode == ''" (click)="searchCustomer(mobileNO_Form.value.mobile)">Search</button>&nbsp;
        </div>
      </div>

    </div>

    <ng-container *ngIf="ledsContainer == 'Registration' ">
      <h5>New User Registration Form</h5>
      <form [formGroup]="userRegistration_Form">
        <div class="row addressContainer">
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">First Name<span class="text-danger">*</span></label>
              <input type="text" formControlName="firstName" class="form-control col-form-label-sm"
                placeholder="First Name">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">Last Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control col-form-label-sm" formControlName="lastName"
                placeholder="Last Name">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">Gender<span class="text-danger">*</span></label>
              <select id="gender" class="form-control marT5" placeholder="--Select Gender--" formControlName="gender">
                <option value="" disabled selected>--Select Gender--</option>
                <option value="2">Male</option>
                <option value="1">Female</option>
                <option value="3">Other</option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">Date of Birth<span class="text-danger">*</span></label>
              <input type="text" class="form-control readOnlyActive" formControlName="dob" placeholder="Date of Birth"
                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' }" bsDatepicker readonly>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">Mobile number<span class="text-danger">*</span></label>
              <input type="text" readonly class="form-control col-form-label-sm" formControlName="mobileNumber"
                placeholder="Mobile No">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="formGroupExampleInput">Email<span class="text-danger">*</span></label>
              <input type="text" class="form-control col-form-label-sm" formControlName="email" placeholder="Email">
            </div>
          </div>
          <div class="col-12">
            <div style="text-align:center;">
              <button type="submit" class="btn green_btn" (click)="modalRef.dismiss('Cross click')">Close</button>&nbsp;
              <button type="submit" class="btn green_btn" [disabled]="userRegistration_Form.invalid" (click)="customerRegistration()">Submit</button>&nbsp;
            </div>
          </div>
        </div>
      </form>
    </ng-container>


    <ng-container *ngIf="ledsContainer == 'addAddress' ">

      <form [formGroup]="addressRegForm">
        <div class="row addressContainer">
          <div class="col-12">
            <label for="add-address">Select Location<span></span></label>
            <location-picker [ngModelOptions]="{standalone: true}"
              [modalOptions]="{locationName: leadObj.pickUpLocation, fullAddress: true}"
              (locationPicker)="onItemClicked($event)" [(ngModel)]="leadObj.pickUpLocation"
              ngDefaultControl></location-picker>
          </div>
        </div>
        <div class="row addressContainer">
          <div class="col-4">
            <div class="form-group">
              <label for="Building Name/Flat Number">Building Name/Flat Number<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="Building Name/Flat Number" formControlName="bflat">
              <div class="text-danger errormsg" *ngIf="(f['bflat'].touched || isSubmited ) && f['bflat'].errors">
                <div *ngIf="f['bflat'].errors['required']">Building Name/Flat Number is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="streetName">Area<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="streetName" formControlName="street">
              <div class="text-danger errormsg" *ngIf="(f['street'].touched || isSubmited ) && f['street'].errors">
                <div *ngIf="f['street'].errors['required']">Area Name is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="landmark">Landmark (Optional)<span></span></label>
              <input type="text" class="form-control marT5" id="landmark" formControlName="land">
              <!--<div class="text-danger errormsg" *ngIf="(f['land'].touched || isSubmited ) && f['land'].errors" >
                      <div *ngIf="f['land'].errors['required']">Landmark (Optional) is required</div>
                    </div>-->
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="city">City<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="city" formControlName="city">
              <div class="text-danger errormsg" *ngIf="(f['city'].touched || isSubmited ) && f['city'].errors">
                <div *ngIf="f['city'].errors['required']">city is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="pincode">Pincode<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="pincode" formControlName="pincode">
              <div class="text-danger errormsg" *ngIf="(f['pincode'].touched || isSubmited ) && f['pincode'].errors">
                <div *ngIf="f['pincode'].errors['required']">pincode is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="state">State<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="state" formControlName="state">
              <div class="text-danger errormsg" *ngIf="(f['state'].touched || isSubmited ) && f['state'].errors">
                <div *ngIf="f['state'].errors['required']">state is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="country">Country<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="country" formControlName="country">
              <div class="text-danger errormsg" *ngIf="(f['country'].touched || isSubmited ) && f['country'].errors">
                <div *ngIf="f['country'].errors['required']">country is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <label>Address Type<span class="text-danger">*</span></label>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Home" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Home
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Office" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Office
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Other" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Other
                  </label>
                </div>
              </div>

            </div>
            <div class="text-danger errormsg" *ngIf="(f['addrType'].touched || isSubmited ) && f['addrType'].errors">
              <div *ngIf="f['addrType'].errors['required']">Address Type is required</div>
            </div>
          </div>


          <div class="col-md-4" *ngIf="f['addrType'].value == 'Other'">
            <label>Address Name<span class="text-danger">*</span></label>
            <div class="form-group">
              <input type="text" class="form-control marT5" id="country" formControlName="addrValue">
              <div class="text-danger errormsg">
                <!-- {{addrValueMsg}} -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div style="text-align:center;">
            <button type="submit" class="btn green_btn">Close</button>&nbsp;
            <button type="submit" class="btn green_btn" (click)="addAddress()">Submit</button>&nbsp;
          </div>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="ledsContainer == 'creatLeads' ">
      <P >Select Member</P>   
      <div class="row membDeckPanel">
        <div class="indiBox card" *ngFor="let data of customerDetails">
          <label class="container">
            <div>
              <img src="./assets/img/male.svg" alt="home" class="userDp" *ngIf="data.gender == '2'" />
              <img src="assets/img/female.svg" alt="home" class="userDp" *ngIf="data.gender== '1'" />
            </div>
            <div>
              <input type="radio" name="featured" id="1" [checked]="selectedCustomerDeatils.customerMRNID == data.customerMRNID" value="" (click)="selectnumber(data)">
              <span class="checkmark"></span>{{data.firstName}} {{data.lastName}}<p class="mrnNum">MRN: {{data.mrn}}
              </p>
            </div>
          </label>
        </div>
        <form [formGroup]="leadsCraetion_Form">
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="formGroupExampleInput">Service Name</label>
                <input type="text" class="form-control col-form-label-sm" formControlName="serviceName" placeholder="Service Name">
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="formGroupExampleInput">Business Name <span>*</span></label>
                <!-- <ng-select [items]="dynamicBusiness" [multiple]="true" [closeOnSelect]="true" [clearable]="true"
                   bindLabel="displayName" bindValue="ID" placeholder="Select Client"
                  (change)="onBusinessSelect($event)">
                  <ng-options *ngFor="let item of dynamicBusiness " [Value]="item.ID">{{item.displayName}}
                  </ng-options>
                </ng-select> -->
                  <select class="form-control col-form-label-sm" formControlName="businessName">
                    <option *ngFor="let item of dynamicBusiness" [value]="item.ID">{{item.displayName}}</option>
                  </select>
    
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="formGroupExampleInput">Discharge summary</label>
                <input type="file" class="form-control col-form-label-sm" placeholder="" formControlName="file" (change)="uploadReports($event)">
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label for="formGroupExampleInput">Remarks</label>
                <textarea  class="form-control col-form-label-sm" placeholder="" formControlName="remarks"></textarea>
              </div>
            </div>
            <div class="col-12">
              <div style="text-align:center;">
                <button type="submit" class="btn green_btn">Close</button>&nbsp;
                <button type="submit" class="btn green_btn" [disabled]="leadsCraetion_Form.invalid" (click)="createLeads()">Submit</button>&nbsp;
              </div>
            </div>
          </div>
        </form>  
        <!-- <div class="indiBox addUserBox ml-0" (click)=" ledsContainer= 'Registration'
        ">
          <img src="./assets/img/user.svg" />
          <p>Add Member</p>
        </div> -->
      </div>
      <!-- <ng-container > -->
      <div class="row">
        <div class="col-4 addressContainer">
          <!-- <div class="row">
            <div class="col-12">
              <P style="float: left;">Select Member</P>   
              <p style="float: right;">Add Member</p>
            </div>
          </div> -->

          
          <!-- <P>Select Address</P>
          <div class="row membDeckPanel">
            <div class="indiBox card" *ngFor="let data of addressDetails ">
              <label class="container">
                <div>
                  <img src="./assets/img/home-address.svg" alt="home" class="userDp" />
                </div>
                <div>
                  <input type="radio" name="featured" id="1"  value="" (click)="selectnumber(data)">
                  <p>{{data?.addressType}}</p>
                  <p><span style="font-size: 10px;">{{data?.address}}</span>|<span
                      style="font-size: 10px;">{{data?.area}}</span></p> 
                        <span class="checkmark"></span>
                </div>
              </label>
            </div>
            <div class="indiBox addUserBox ml-0" (click)=" ledsContainer= 'addAddress'
            ">
              <img src="./assets/img/home-address.svg" />
              <p>Add Address</p>
            </div>
          </div> -->
        </div>
        <div >
               
        </div>

      </div>
    </ng-container>


  </div>

</ng-template>

<ng-template #addPlansModal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Add Plans to Leads</p>

    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">
    <P >User Details</P>   
    <div class="row membDeckPanel" >
      <div class="indiBox card" style="min-width: 325px !important;" >
        <label class="container">
          <div>
            <img src="./assets/img/male.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender == '2'" />
            <img src="assets/img/female.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender== '1'" />
          </div>
          <div>
            <!-- <input type="radio" name="featured" id="1" [checked] value="" (click)="selectnumber(data)">
            <span class="checkmark"></span> -->
           <p>Name : {{selectedLeadDetails.customerName}}</p>  
           <p class="mrnNum">MRN: {{selectedLeadDetails.mrn}}
            </p>
          </div>
        </label>
      </div>
      <!-- <div class="indiBox addUserBox ml-0" (click)=" ledsContainer= 'Registration'
      ">
        <img src="./assets/img/user.svg" />
        <p>Add Member</p>
      </div> -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="formGroupExampleInput">Programs</label>
          <ng-select [items]="ListTagsWithPackages" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
             bindLabel="Name" bindValue="TagDes" placeholder="Select Package Tag"
            (change)="onTagSecetion($event)">
            <ng-options *ngFor="let item of ListTagsWithPackages " [Value]="item.TagDes">{{item.Name}}
            </ng-options>
          </ng-select>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="formGroupExampleInput">Plans<span class="text-danger">*</span></label>
          <ng-select [items]="listOfPackages" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
             bindLabel="package_name"  (change)="onPackageSelect($event)" bindValue="package_code" placeholder="Select Package"
            >
            <ng-options *ngFor="let item of listOfPackages " [Value]="item.package_code">{{item.package_name}}
            </ng-options>
          </ng-select>
        </div>
      </div>
      <div class="col-12" *ngIf="selectedPackages.length > 0 ">
        <div class="table_main tableShadow" style="margin-top:0px ;">
          <table class="table table-striped table-responsive">
            <thead>
              <tr class="tbl_name">
                <th>S.NO</th>
                <th>Package Name</th>
                <th>Package Cost</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of selectedPackages;let i=index ">
                <td>
                  {{i+1}}
                </td>
                <td>{{data.plan_name}}</td>
                <td>{{data.amount}}</td>
                <td><button class="btn btn-primary" (click)="deletePackages(i)">Delete</button></td>
      
              </tr>
      
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 " style="text-align: center;" >
        <button class="btn btn-success" (click)="updateLeads('update')">Proceed</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ledsToOrdersModal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Convert leads to Order</p>

    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">
    <ng-container *ngIf="ordersContainer == 'orderDetails' ">
      <!-- <ng-container > -->
      <div class="row">
        <div class="col-7 addressContainer">
          <P >User Details</P>   
          <!-- <div class="row">
            <div class="col-12">
              <P style="float: left;">Select Member</P>   
              <p style="float: right;">Add Member</p>
            </div>
          </div> -->

          <div class="row membDeckPanel">
            <div class="indiBox card cards" >
              <label class="container">
                <div>
                  {{selectedCustomerDeatils.customerGender}}
                  <img src="./assets/img/male.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender == '2'" />
                  <img src="assets/img/female.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender== '1'" />
                </div>
                <div>
                  <!-- <input type="radio" name="featured" id="1" [checked] value="" (click)="selectnumber(data)">
                  <span class="checkmark"></span> -->
                 <p>Name : {{selectedLeadDetails.customerName}}</p>  
                 <p class="mrnNum">MRN: {{selectedLeadDetails.mrn}}
                  </p>
                </div>
              </label>
            </div>
            <!-- <div class="indiBox addUserBox ml-0" (click)=" ledsContainer= 'Registration'
            ">
              <img src="./assets/img/user.svg" />
              <p>Add Member</p>
            </div> -->
          </div>
          <P>Select Address</P>
          <div class="row membDeckPanel">
            <div class="indiBox card cards" *ngFor="let data of addressDetails ">
              <label class="container">
                <div>
                  <img src="./assets/img/home-address.svg" alt="home" class="userDp" />
                </div>
                <div>
                  <input type="radio" name="featured" id="1"  value="" [checked]="selectedAddressDetails.customerAddrID == data.customerAddrID " (click)="selectAddress(data)">
                  <p>{{data?.addressType}}</p>
                  <p><span style="font-size: 10px;">{{data?.address}}</span>|<span
                      style="font-size: 10px;">{{data?.area}}</span></p> 
                        <span class="checkmark"></span>
                </div>
              </label>
            </div>
            <div class="indiBox addUserBox ml-0 cards" (click)=" ordersContainer = 'addAddress'
            ">
              <img src="./assets/img/home-address.svg" />
              <p>Add Address</p>
            </div>
          </div>
        </div>
        <div class="col-5 leadsContainer">
          <div class="col-12" *ngIf="selectedPackagesForOrders.length > 0 ">
            <div class="table_main tableShadow" style="margin-top:0px ;">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr class="tbl_name">
                    <th>S.NO</th>
                    <th>Plan Name</th>
                    <th>Plan Cost</th>
                    <!--<th>Action</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of selectedPackagesForOrders;let i=index ">
                    <td>
                      {{i+1}}
                    </td>
                    <td>{{data.plan_name}}</td>
                    <td>{{data.amount}}</td>
                    <!--<td><button class="btn btn-primary" (click)="deleteOrderPackages(i)">Delete</button></td>-->
          
                  </tr>
          
                </tbody>
              </table>
              
            </div>
            <div class="col-12">
              <p *ngIf="ordersErrorMessages !==''" class="text-danger">{{ordersErrorMessages}}</p>
            </div>
            <div class="col-12" style="text-align: center;">
              <button class="btn btn-success" (click)="processOrder()">Assign</button>
            </div>
          </div>
        </div>

      </div>
    </ng-container>
    <ng-container *ngIf="ordersContainer == 'addAddress' ">
      <div class="row">
        <button type="button" class="numberBtn" (click)="ordersContainer = 'orderDetails'">
          &lt;&lt;
      </button>
      </div>
      <h6>Add Address</h6>
      <form [formGroup]="addressRegForm">
        <div class="row addressContainer">
          <div class="col-12">
            <label for="add-address">Select Location<span></span></label>
            <location-picker [ngModelOptions]="{standalone: true}"
              [modalOptions]="{locationName: leadObj.pickUpLocation, fullAddress: true}"
              (locationPicker)="onItemClicked($event)" [(ngModel)]="leadObj.pickUpLocation"
              ngDefaultControl></location-picker>
          </div>
        </div>
        <div class="row addressContainer">
          <div class="col-4">
            <div class="form-group">
              <label for="Building Name/Flat Number">Building Name/Flat Number<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="Building Name/Flat Number" formControlName="bflat">
              <div class="text-danger errormsg" *ngIf="(f['bflat'].touched || isSubmited ) && f['bflat'].errors">
                <div *ngIf="f['bflat'].errors['required']">Building Name/Flat Number is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="streetName">Area<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="streetName" formControlName="street">
              <div class="text-danger errormsg" *ngIf="(f['street'].touched || isSubmited ) && f['street'].errors">
                <div *ngIf="f['street'].errors['required']">Area Name is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="landmark">Landmark (Optional)<span></span></label>
              <input type="text" class="form-control marT5" id="landmark" formControlName="land">
              <!--<div class="text-danger errormsg" *ngIf="(f['land'].touched || isSubmited ) && f['land'].errors" >
                      <div *ngIf="f['land'].errors['required']">Landmark (Optional) is required</div>
                    </div>-->
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="city">City<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="city" formControlName="city">
              <div class="text-danger errormsg" *ngIf="(f['city'].touched || isSubmited ) && f['city'].errors">
                <div *ngIf="f['city'].errors['required']">city is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="pincode">Pincode<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="pincode" formControlName="pincode">
              <div class="text-danger errormsg" *ngIf="(f['pincode'].touched || isSubmited ) && f['pincode'].errors">
                <div *ngIf="f['pincode'].errors['required']">pincode is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="state">State<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="state" formControlName="state">
              <div class="text-danger errormsg" *ngIf="(f['state'].touched || isSubmited ) && f['state'].errors">
                <div *ngIf="f['state'].errors['required']">state is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="country">Country<span class="text-danger">*</span></label>
              <input type="text" class="form-control marT5" id="country" formControlName="country">
              <div class="text-danger errormsg" *ngIf="(f['country'].touched || isSubmited ) && f['country'].errors">
                <div *ngIf="f['country'].errors['required']">country is required</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <label>Address Type<span class="text-danger">*</span></label>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Home" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Home
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Office" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Office
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    <input type="radio" formcontrolname="address" value="Other" id="1" formControlName="addrType">
                    <span class="checkmark"></span>Other
                  </label>
                </div>
              </div>

            </div>
            <div class="text-danger errormsg" *ngIf="(f['addrType'].touched || isSubmited ) && f['addrType'].errors">
              <div *ngIf="f['addrType'].errors['required']">Address Type is required</div>
            </div>
          </div>


          <div class="col-md-4" *ngIf="f['addrType'].value == 'Other'">
            <label>Address Name<span class="text-danger">*</span></label>
            <div class="form-group">
              <input type="text" class="form-control marT5" id="country" formControlName="addrValue">
              <div class="text-danger errormsg">
                <!-- {{addrValueMsg}} -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div style="text-align:center;">
            <button type="submit" class="btn green_btn" (click)="modalRef.dismiss('Cross click')">Close</button>&nbsp;
            <button type="submit" class="btn green_btn" (click)="addAddress()" [disabled]="addressRegForm.invalid" >Submit</button>&nbsp;
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</ng-template>
<ng-template #uploadDischargeSummary>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Upload Discharge Summary</p>
    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">
    <P >User Details</P>   
    <div class="row membDeckPanel" >
      <div class="indiBox card" style="min-width: 325px !important;" >
        <label class="container">
          <div>
            <img src="./assets/img/male.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender == '2'" />
            <img src="assets/img/female.svg" alt="home" class="userDp" *ngIf="selectedLeadDetails.customerGender== '1'" />
          </div>
          <div>
            <!-- <input type="radio" name="featured" id="1" [checked] value="" (click)="selectnumber(data)">
            <span class="checkmark"></span> -->
           <p>Name : {{selectedLeadDetails.customerName}}</p>  
           <p class="mrnNum">MRN: {{selectedLeadDetails.mrn}}
            </p>
          </div>
        </label>
      </div>
      <!-- <div class="indiBox addUserBox ml-0" (click)=" ledsContainer= 'Registration'
      ">
        <img src="./assets/img/user.svg" />
        <p>Add Member</p>
      </div> -->
    </div>
    <form [formGroup]="discharge_form">
      <div class="col-12">
        <div class="form-group">
          <label for="formGroupExampleInput">Discharge summary</label>
          <input type="file"  class="form-control col-form-label-sm" placeholder="" formControlName="file"  (change)="uploadReports($event)">
        </div>
      </div>
    </form>
    <div class="col-12 " style="text-align: center;" >
      <button class="btn btn-success" (click)="updateLeads('dischargeSummary')" [disabled]="discharge_form.invalid">Submit</button>
    </div>
  </div>
</ng-template>
<ng-template #showLeadsHistoryModal>
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Convert leads to Order</p>

    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body customModalBody">
        <table class="table table-striped table-hover table-responsive customTable">
            <thead>
                <tr>
                    <th>Order</th>
                    <th>User Name</th>
                    <th>User ID</th>
                    <th>Role</th>
                    <th>Action</th>
                    <th>Order Status</th>
                     <th>Updated On</th> 
                    <th>Text</th>

                </tr>


            <tbody>


                <tr >
                    

                </tr>
            </tbody>
        </table>

  </div>
</ng-template>